// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3Hy7y","tab":"ProcedureTabs_tab__4BGEQ"};